// Commands are local UI actions. Add future commands here instead of querying
// the server while the operator types.
export const composerCommands = [{
  id: "schedule", command: "//agendar", label: "Agendar",
  description: "Programar mensagem para este cliente"
}, {
  id: "kanban", command: "//kanban", label: "Kanban",
  description: "Adicionar ou mover este cliente entre etapas"
}, {
  id: "tags", command: "//tags", label: "Tags",
  description: "Adicionar ou remover tags deste cliente"
}];

export function getCommandSuggestions(text) {
  const query = String(text || "").toLowerCase();
  if (!/^\/\/\S*$/.test(query)) return [];
  return composerCommands.filter(item => item.command.startsWith(query));
}

export function extractScheduleCommand(text) {
  const result = extractComposerCommand(text);
  const matched = result.command?.id === "schedule";
  return { matched, body: matched ? result.body : String(text || "") };
}

export function extractComposerCommand(text) {
  const value = String(text || "");
  const match = value.match(/^\/\/([^\s]+)(?:\s+|$)/);
  const command = match ? composerCommands.find(item => item.command.toLowerCase() === `//${match[1].toLowerCase()}`) : null;
  return { command: command || null, body: command ? value.slice(match[0].length) : value };
}
